import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const BrokenBuildingIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };

  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 39 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.3531 30.715V33.5906H1.21405V7.68922C1.21405 4.11159 2.83289 1.21387 7.6894 1.21387H23.8778C28.7343 1.21387 30.3531 4.11159 30.3531 7.68922V11.7449"
        stroke="currentColor"
        stroke-width="2.42808"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.70038 24.6875H12.5569"
        stroke="currentColor"
        stroke-width="2.42808"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.70038 17.5586H12.5569"
        stroke="currentColor"
        stroke-width="2.42808"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.70038 10.1172H12.5569"
        stroke="currentColor"
        stroke-width="2.42808"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.0323 10.1172H23.8888"
        stroke="currentColor"
        stroke-width="2.42808"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.032 14.6184C29.6009 14.0126 31.2885 15.1725 31.2849 16.8543L31.2645 26.0639C31.2609 27.7084 29.6369 28.8587 28.0844 28.3164L25.1866 27.3036C25.0169 27.6652 24.7895 28.0071 24.502 28.3136C23.0311 29.8823 20.5674 29.9616 18.9985 28.4909C17.9426 27.5009 17.5618 26.0612 17.8734 24.748L16.8302 24.3844C16.1005 24.1293 15.5949 23.4617 15.5472 22.6902L15.4376 20.9195C15.3862 20.084 15.8824 19.3113 16.6632 19.0098L28.032 14.6184ZM19.7412 25.4015C19.6645 25.998 19.8655 26.6211 20.3371 27.0633C21.1173 27.7946 22.3429 27.7551 23.0743 26.9751C23.1691 26.874 23.2493 26.7645 23.3181 26.6508L19.7412 25.4015ZM29.3275 16.8504C29.3282 16.5452 29.0216 16.3339 28.7368 16.4438L17.394 20.8247L17.4991 22.5444L28.7296 26.4689C29.0113 26.5674 29.3064 26.3585 29.3071 26.0599L29.3275 16.8504ZM35.237 24.8595C35.6311 25.2292 35.6512 25.8484 35.2816 26.2426C34.912 26.6367 34.2928 26.6566 33.8985 26.2871L32.5898 25.0601C32.1955 24.6905 32.1749 24.0707 32.5445 23.6764C32.9142 23.282 33.534 23.2628 33.9283 23.6325L35.237 24.8595ZM37.583 20.6897C38.1231 20.6724 38.575 21.096 38.5925 21.6361C38.6099 22.1763 38.1861 22.6281 37.646 22.6456L34.4761 22.7484C33.936 22.7658 33.4843 22.3419 33.4666 21.802C33.4492 21.2617 33.8735 20.8092 34.4137 20.7918L37.583 20.6897ZM34.5836 17.0368C35.0415 16.8464 35.5789 17.0301 35.8199 17.4758C36.077 17.9512 35.8999 18.5454 35.4247 18.8026L35.4239 18.8019L33.5538 19.8142C33.0784 20.0712 32.4848 19.8937 32.2277 19.4182C31.9707 18.9429 32.1471 18.3493 32.6223 18.0921L34.4931 17.0805L34.5836 17.0368Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.61194"
      />
    </svg>
  );
};
const BrokenBuildingIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={BrokenBuildingIconSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default BrokenBuildingIcon;
